// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateBrazilianCity(cityValue: string): ?UserInputValidationError {
  return cityValue && cityValue.length > 0 ? undefined : { id: 'empty' };
}
